import { render, staticRenderFns } from "./jbsmall_button.vue?vue&type=template&id=35cded1c"
import script from "./jbsmall_button.vue?vue&type=script&lang=js"
export * from "./jbsmall_button.vue?vue&type=script&lang=js"
import style0 from "./jbsmall_button.vue?vue&type=style&index=0&id=35cded1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports